import { IFieldRequired } from "./boomtypes";

export enum ValidationTypes {
    REGEX = "REGEX",
    LETTERS = "LETTERS",
    DIGITS = "DIGITS",
    SYMBOLS = "SYMBOLS",
    EMAIL = "EMAIL",
    URL = "URL",
    MIN_MAX_QUANTITY = "MIN_MAX_QUANTITY",
    MIN_MAX_SIZE = "MIN_MAX_SIZE",
    FILE_TYPE_FORMAT = "FILE_TYPE_FORMAT",
    MIN_MAX_DATE = "MIN_MAX_DATE",
    CURRENCY = "CURRENCY",
    DOMAIN = "DOMAIN",
    REQUIRED = "IS_REQUIRED",
    MIN_MAX_STRING_LENGTH = "MIN_MAX_STRING_LENGTH",
    MIN_MAX_OPTIONS = "MIN_MAX_OPTIONS",
}

export enum IValidateBy {
    LENGTH = "LENGTH",
    WORD = "WORD",
    SIZE = "SIZE",
    TYPE_FORMAT = "TYPE_FORMAT",
}

interface IMinMaxStrinLenght {
    enabled: boolean;
    min: number;
    max: number;
    message: string;
    validateBy: IValidateBy;
}

interface IMinMaxOptions {
    enabled: boolean;
    min: number;
    max: number;
    message: string;
    validateBy: IValidateBy;
}
interface IMinMaxQuantityValue {
    enabled: boolean;
    min: number;
    max: number;
    message: string;
    validateBy: IValidateBy;
}

interface IMinMaxSizeValue {
    enabled: boolean;
    sizeType: string;
    min: number;
    max: number;
    message: string;
    validateBy: IValidateBy;
}

interface IFileTypeFormatValue {
    enabled: boolean;
    message: string;
    validateBy: IValidateBy;
    types: Array<string>;
    formats: Array<string>;
    fileTypeFormat: string;
}

interface IMinMaxDateValue {
    min: {
        option: string;
        value: string;
    };
    max: {
        option: string;
        value: string;
    };
    enabled: boolean;
    message: string;
}

interface IFRegEx {
    value: string;
    message: string;
    enabled: boolean;
}
interface IFDomain {
    value: string;
    message: string;
    enabled: boolean;
}
interface IFUrl {
    value: boolean;
    message: string;
    enabled: boolean;
}
interface IFEmail {
    value: boolean;
    message: string;
    enabled: boolean;
}
interface IFDigits {
    value: boolean;
    message: string;
    enabled: boolean;
}
interface IFLetters {
    value: boolean;
    message: string;
    enabled: boolean;
}
interface IFSymbols {
    value: boolean;
    message: string;
    enabled: boolean;
}
interface IFCurrency {
    value: boolean;
    message: string;
    enabled: boolean;
}

interface IFDomain {
    message: string;
    value: string;
    enabled: boolean;
}

export type IFieldsValidations = {
    [ValidationTypes.URL]?: IFUrl;
    [ValidationTypes.EMAIL]?: IFEmail;
    [ValidationTypes.REGEX]?: IFRegEx;
    [ValidationTypes.DIGITS]?: IFDigits;
    [ValidationTypes.DOMAIN]?: IFDomain;
    [ValidationTypes.LETTERS]?: IFLetters;
    [ValidationTypes.SYMBOLS]?: IFSymbols;
    [ValidationTypes.REQUIRED]?: IFieldRequired;
    [ValidationTypes.CURRENCY]?: IFCurrency;
    [ValidationTypes.MIN_MAX_DATE]?: IMinMaxDateValue;
    [ValidationTypes.MIN_MAX_QUANTITY]?: IMinMaxQuantityValue;
    [ValidationTypes.MIN_MAX_SIZE]?: IMinMaxSizeValue;
    [ValidationTypes.FILE_TYPE_FORMAT]?: IFileTypeFormatValue;
    [ValidationTypes.MIN_MAX_STRING_LENGTH]?: IMinMaxStrinLenght;
    [ValidationTypes.MIN_MAX_OPTIONS]?: IMinMaxOptions;
};
export interface IValidationTypesFE {
    [ValidationTypes.URL]: IFUrl;
    [ValidationTypes.EMAIL]: IFEmail;
    [ValidationTypes.REGEX]: IFRegEx;
    [ValidationTypes.DIGITS]: IFDigits;
    [ValidationTypes.DOMAIN]: IFDomain;
    [ValidationTypes.LETTERS]: IFLetters;
    [ValidationTypes.SYMBOLS]: IFSymbols;
    [ValidationTypes.CURRENCY]: IFCurrency;
    [ValidationTypes.MIN_MAX_DATE]: IMinMaxDateValue;
    [ValidationTypes.MIN_MAX_QUANTITY]: IMinMaxQuantityValue;
    [ValidationTypes.MIN_MAX_SIZE]: IMinMaxSizeValue;
    [ValidationTypes.FILE_TYPE_FORMAT]: IFileTypeFormatValue;
    [ValidationTypes.MIN_MAX_STRING_LENGTH]: IMinMaxStrinLenght;
    [ValidationTypes.MIN_MAX_OPTIONS]: IMinMaxOptions;
}

/* -- For Backend -- */

interface IMinMaxQuantityValueBE {
    min: { type: number };
    max: { type: number };
    validateBy: { type: IValidateBy };
    enabled: boolean;
}

interface IMinMaxSizeValueBE {
    min: { type: number };
    max: { type: number };
    sizeType: { type: string };
    validateBy: { type: IValidateBy };
    enabled: boolean;
}

interface IFileTypeFormatValueBE {
    enabled: boolean;
    validateBy: { type: IValidateBy };
    types: { type: Array<string> };
    formats: { type: Array<string> };
    fileTypeFormat: { type: string };
}

interface IMinMaxDateValueBE {
    min: { type: string };
    max: { type: string };
    enabled: boolean;
}
export interface IVRegex {
    type: ValidationTypes.REGEX;
    value: string;
    enabled: boolean;
}
export interface IVLetters {
    type: ValidationTypes.LETTERS;
    value: boolean;
    enabled: boolean;
}
export interface IVDigits {
    type: ValidationTypes.DIGITS;
    value: boolean;
    enabled: boolean;
}
export interface IVSymbols {
    type: ValidationTypes.SYMBOLS;
    value: boolean;
    enabled: boolean;
}
export interface IVEmail {
    type: ValidationTypes.EMAIL;
    value: boolean;
    enabled: boolean;
}
export interface IVUrl {
    type: ValidationTypes.URL;
    value: boolean;
    enabled: boolean;
}
export interface IVMinMaxQuantity {
    type: ValidationTypes.MIN_MAX_QUANTITY;
    value: IMinMaxQuantityValue;
    enabled: boolean;
}

export interface IVMinMaxSize {
    type: ValidationTypes.MIN_MAX_SIZE;
    value: IMinMaxSizeValue;
    enabled: boolean;
}

export interface IFileTypeFormat {
    type: ValidationTypes.FILE_TYPE_FORMAT;
    value: IFileTypeFormatValue;
    enabled: boolean;
}

export interface IVMinMaxDate {
    type: ValidationTypes.MIN_MAX_DATE;
    value: IMinMaxDateValue;
    enabled: boolean;
}
export interface IVCurrency {
    type: ValidationTypes.CURRENCY;
    value: boolean;
    enabled: boolean;
}
export interface IVDomain {
    type: ValidationTypes.DOMAIN;
    value: string;
    enabled: boolean;
}
export type IValidationTypesBE = Array<
    | IVRegex
    | IVLetters
    | IVDigits
    | IVSymbols
    | IVEmail
    | IVUrl
    | IMinMaxQuantityValueBE
    | IMinMaxSizeValueBE
    | IFileTypeFormatValueBE
    | IMinMaxDateValueBE
    | IVCurrency
    | IVDomain
>;
